import { useTranslation } from 'react-i18next';

import { InfoRow } from '@app/shared/ui/molecules/Common';
import { StatusButton } from '@app/shared/ui/atoms/Admin/Withdrawals';
import { CopyableInfoRow } from '@app/shared/ui/molecules/Admin/WithdrawalDetails';
import { formatBalance, formatNumber } from '@app/shared/utils/common';
import { PriceType } from '@app/shared/types/common';
import { WithdrawalStatus } from '@app/store/slices/withdrawal/withdrawalTypes';

interface InfoSectionProps {
  reviewer: {
    telegramUsername?: string | null;
  } | null;
  withdrawal: {
    status: WithdrawalStatus;
    amount: string;
    fee: string;
    total: string;
    address: string;
  };
  user: {
    telegramId?: string | null;
    telegramUsername?: string | null;
    fullName?: string | null;
  } | null;
}

export function InfoSection({ reviewer, withdrawal, user }: InfoSectionProps) {
  const { t } = useTranslation();

  const telegramUsername = user?.telegramUsername || '';
  const telegramId = user?.telegramId || '';

  return (
    <section>
      <InfoRow
        label={t('admin_withdrawal_details.latest_changes')}
        value={<b className="truncate">{reviewer?.telegramUsername}</b>}
        isEqual
      />
      <InfoRow
        label={t('withdrawal.status')}
        value={<StatusButton variant={withdrawal.status} as="span" className="py-0.5" />}
        isEqual
      />
      <InfoRow
        label={t('withdrawal.amount_label')}
        value={<b>{formatBalance(PriceType.TON, withdrawal.amount)}</b>}
        isEqual
      />
      <InfoRow
        label={t('withdrawal.fee_label')}
        value={<b>{formatBalance(PriceType.TON, withdrawal.fee)}</b>}
        isEqual
      />

      <CopyableInfoRow
        label={t('withdrawal.send')}
        valueToDisplay={formatBalance(PriceType.TON, withdrawal.total)}
        valueToCopy={formatNumber(withdrawal.total)}
        isEqual
      />
      <CopyableInfoRow
        label={t('withdrawal.address_label')}
        valueToDisplay={withdrawal.address}
        valueToCopy={withdrawal.address}
        isEqual
      />
      <CopyableInfoRow
        label="Telegram"
        valueToDisplay={telegramUsername}
        valueToCopy={`@${telegramUsername}`}
        isEqual
      />
      <CopyableInfoRow
        label="Telegram ID"
        valueToDisplay={telegramId}
        valueToCopy={telegramId}
        isEqual
      />

      <InfoRow
        label={t('common.name')}
        value={<b>{user?.fullName}</b>}
        isEqual
        withBottomBorder={false}
      />
    </section>
  );
}
